import React from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from '@components/atoms/typography';

import { Timer } from '../start/timer';

import { ExpiredStepContainer } from './styles';

export const ExpiredStep: React.FC = () => {
    const { t } = useTranslation();

    return (
        <ExpiredStepContainer>
            <Timer />
            <img
                src='https://static.dataspike.io/images/sdk/verification/time-expired.png'
                alt='Time expired'
                className='expired-icon'
            />
            <Typography tag='h2' variant='h2' className='title'>
                {t('docVerificationWizard.expired.title')}
            </Typography>
            <Typography tag='div' variant='text' color='text-light' className='sub-title'>
                {t('docVerificationWizard.expired.subTitle')}
            </Typography>
        </ExpiredStepContainer>
    );
};
